// const api = "http://localhost:1341/api";
// const host = "http://localhost:1341";

const api = "https://howardson-api.wsio-api.com/api";
const host = "https://howardson-api.wsio-api.com";

const locales = [];
const loqateKey = "AY75-WB66-NW49-BF43";

export { api, host, locales, loqateKey };